import { paths } from "components/App/paths";

import { sentenceCase } from "./sentenceCase";

interface KeyValue {
  key: string;
  value: string;
}

const routeTitles: KeyValue[] = [
  { key: paths.HOME, value: "Home" },
  { key: paths.monitor.ALERTS, value: "Raised alerts | Monitor" },
  { key: paths.settings.RULES, value: "Alerting rules | Settings" },
  { key: paths.HOME, value: "Home" },
  {
    key: paths.settings.INTEGRATIONS_ACCOUNTING,
    value: "Accounting | Integrations | Settings",
  },
  {
    key: paths.settings.INTEGRATIONS_BANKING,
    value: "Banking | Integrations | Settings",
  },
  {
    key: paths.settings.INTEGRATIONS_MANAGE_SOURCES,
    value: "Manage TrueLayer sources | Banking | Integrations | Settings",
  },
  {
    key: paths.settings.INTEGRATIONS_COMMERCE,
    value: "Commerce | Integrations | Settings",
  },
  {
    key: paths.settings.INTEGRATIONS_OTHER,
    value: "Other | Integrations | Settings",
  },
  { key: paths.settings.USERS, value: "Manage users | Settings" },
  { key: paths.settings.DATA_TYPES, value: "Data types | Settings" },
  { key: paths.settings.LINK_SETTINGS, value: "Link settings | Settings" },
  {
    key: paths.monitor.CONNECTOR_HEALTH,
    value: "Offline connectors | Monitor",
  },
  {
    key: paths.settings.BILLING,
    value: "Billing | Settings",
  },
  {
    key: paths.products.SYNC_FOR_COMMERCE,
    value: "Sync For Commerce | Products",
  },
  {
    key: paths.products.SYNC_FOR_EXPENSES,
    value: "Sync For Expenses | Products",
  },
  {
    key: paths.spendInsights.company.INSIGHTS,
    value: "Spend Insights",
  },
];

const uuidRegex =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const acronyms = ["API"];

export const getTitleForRoute = (path: string): string => {
  const generateTitle = (): string => {
    if (!path) {
      return "";
    }

    const parts = path.slice(1).split("/");

    const newParts = parts.map((part) => {
      if (uuidRegex.test(part)) return part;

      return sentenceCase(part);
    });

    newParts.reverse();

    let newTitle = newParts.join(" | ");

    acronyms.forEach((acronym) => {
      const regex = new RegExp(`\\b${acronym.toLowerCase()}\\b`, "i");
      newTitle = newTitle.replace(regex, acronym);
    });

    return newTitle;
  };

  const title =
    routeTitles.find((a) => a.key.toLowerCase() === path?.toLowerCase())
      ?.value ?? generateTitle();
  return title ? `${title} | Codat Portal` : "Codat Portal";
};
